// John Eldhose 20200609
const industries = ['Civil and Hydrology', 'Construction', 'GIS', 'Land Surveying', 'Mining', 'Accident Investigation', 'Agriculture', 'Other'];

export default industries;



// WEBPACK FOOTER //
// ./src/components/lib/industries.js